import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { apiPublicPost } from '../api';
import { resetErrorMessage } from './resetErrors';

const RecoverPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [recoveryKey, setRecoveryKey] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setSubmitting(true);
    try {
      await apiPublicPost('/recover', { email, recoveryKey, newPassword });
      navigate('/login?recovered=true', { replace: true });
    } catch (err) {
      setError(await resetErrorMessage(err, 'Invalid email or recovery key.'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page-container container">
      <div className="auth-header-section">
        <img src="/chaptery-mark.svg" alt="Chaptery Logo" className="auth-logo" />
        <h1>Account Recovery</h1>
        <p className="subtitle">Reset your password using your recovery key.</p>
      </div>

      <div className="auth-wrapper">
        <form className="recover-form" onSubmit={handleSubmit}>
          {error && (
            <div className="feedback-banner feedback-error" role="alert" style={{ marginBottom: '1rem' }}>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="recover-email">Email Address</label>
            <input
              id="recover-email"
              type="email"
              className="form-input"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="recover-key">Recovery Key</label>
            <input
              id="recover-key"
              type="text"
              className="form-input"
              placeholder="XXXXX-XXXXX-XXXXX-XXXXX-XXXXX"
              value={recoveryKey}
              onChange={e => setRecoveryKey(e.target.value)}
              required
              spellCheck={false}
              autoComplete="off"
            />
          </div>

          <div className="form-group">
            <label htmlFor="recover-password">New Password</label>
            <input
              id="recover-password"
              type="password"
              className="form-input"
              value={newPassword}
              onChange={e => setNewPassword(e.target.value)}
              required
              autoComplete="new-password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="recover-confirm">Confirm New Password</label>
            <input
              id="recover-confirm"
              type="password"
              className="form-input"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              required
              autoComplete="new-password"
            />
          </div>

          <button type="submit" className="btn-primary" disabled={submitting} style={{ width: '100%' }}>
            {submitting ? 'Resetting…' : 'Reset Password'}
          </button>
        </form>
      </div>

      <div className="auth-bottom-links">
        <Link to="/login">Back to Sign In</Link>
      </div>
    </div>
  );
};

export default RecoverPage;
